export interface ProfileCacheEntry<TResearch = any> {
  research: TResearch[]
  offset: number
  hasMore: boolean
  stats: { total: number; public: number; private: number }
  statsLoaded: boolean
  visibleCount: number
  timestamp: number
}

const PROFILE_CACHE_TTL_MS = 1000 * 60 * 3 // 3 minutes
export const PROFILE_CACHE_TTL = PROFILE_CACHE_TTL_MS
const profileCache = new Map<number, ProfileCacheEntry>()

export function getProfileCache(userId: number): ProfileCacheEntry | null {
  const entry = profileCache.get(userId)
  if (!entry) {
    return null
  }

  const isExpired = Date.now() - entry.timestamp > PROFILE_CACHE_TTL_MS
  if (isExpired) {
    profileCache.delete(userId)
    return null
  }

  return entry
}

export function setProfileCache(userId: number, data: Omit<ProfileCacheEntry, 'timestamp'>) {
  profileCache.set(userId, {
    ...data,
    timestamp: Date.now()
  })
}

export function clearProfileCache(userId?: number) {
  if (typeof userId === 'number') {
    profileCache.delete(userId)
    return
  }
  profileCache.clear()
}


